// extracted by mini-css-extract-plugin
module.exports = {"buttonCreateRoom":"debates_buttonCreateRoom__VxTZu","spacing":"debates_spacing__3wbx_","error":"debates_error__ZOxMX"};